/**
 * @date: 3/17/22
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2022 MaxMD Corporation, All Rights Reserved.
 *
 */

import React, {useEffect, useRef, useState} from "react";
import {Alert, CircularProgress, Container, Grid} from "@mui/material";
import BasicPie from "./BasicPie";
import {ApiUrl} from "../utils/portal-urls";
import {handleHttpResponse} from "../utils/http-helpers";
import BasicBar from "./BasicBar";
import makeStyles from "@mui/styles/makeStyles";
import {convertDateToTimeString} from "../utils/cert-helper";


const PIE_MINI_PERCENTAGE = 5;

export const dataOrganizer = (data, ref) => {
    const obj = {name: "others", value: 0};
    const sum = data.reduce((a, b) => a + (b['value'] || 0), 0);
    const othersArray = [];

    const newData = data.filter( d => {
        const percent = ((d.value / sum) * 100).toFixed(0);
        if (percent < PIE_MINI_PERCENTAGE) {
            obj.value += d.value;
            othersArray.push(d);
            return false;
        }
        return true;
    })
    obj.value > 0 && newData.push(obj);
    ref.current = othersArray;
    return newData;
}

export default function LastPublishChartsWidget(props){

    const [publish, setPublish] = useState(props.publish || null);
    const [loading, setLoading] = useState(false);
    const [hispsPieData, setHispsPieData] = useState(props.hispsPieData || null);
    const [errorBarData, setErrorBarData] = useState(props.errorBarData || null);

    useEffect(() => {
        if (!publish){
            setLoading(true);
            // fetch(ApiUrl.Published.lastPublished.endpoint)
            console.info(ApiUrl.Published.getPublication.getPath("last", true, false));
            fetch(ApiUrl.Published.getPublication.getPath("last", true, false))
                .then(handleHttpResponse)
                .catch( err => {
                    setLoading(false);
                    if (err) {
                        console.error(err);
                    }
                })
                .then( res => {
                    setLoading(false);
                    if (res) {
                        renderData(res);
                    }
                })
        }
    }, []);

    const renderData = (data) => {
        setPublish(data.publish);
        setHispsPieData(data.hispRecordsPie);
        setErrorBarData(data.errorBar);
    }

    return (<Container maxWidth='xl'>

        {!loading && publish && <ShowPublishWidget publish={publish} hispsPieData={hispsPieData} errorBarData={errorBarData} /> }
        {loading && <Alert severity='info' icon={<CircularProgress />} style={{lineHeight: '37px'}} > Loading charts ... </Alert>}
        {!loading && !publish && <Alert severity='info' icon={false} style={{lineHeight: '37px'}} > No publish record is found </Alert>}
    </Container> );
}


const useStyles = makeStyles((theme) => ({
    infoWrapper: {
        color: '#999999',
        '& div': {
            lineHeight: '30px',
            '& strong': {
                color: '#337AB799', marginLeft: 5
            }
        }
    }
}));

export function ShowPublishWidget(props){
    const classes = useStyles();
    // const {publish, hispsPieData, errorBarData} = props;
    const {publish, hispsPieData, errorBarData} = props;
    const othersRef = useRef();

    const organize = () => {
        return dataOrganizer(hispsPieData, othersRef);
    }

    const getConsumerAccessRate = (publishabilityMap) => {
        var total = 0;
        var access = 0;
        for (var type in publishabilityMap){
            var count = parseInt(publishabilityMap[type]);
            if (type == 3 || type == "3" || type == 2 || type == "2"){
                access += count;
            }
            total += count;
        }
        if (total === 0){
            return "0%";
        } else {
            var rate = access * 100 / total;
            return `${rate.toFixed(2)}%`;

        }

    }

    return ( <div>
            <Grid container mt={2}>
        {/*<Grid container spacing={3}>*/}
                <Grid item xs={12} md={2} lg={2}>
                    {publish && <div className={classes.infoWrapper}>
                        <div style={{whiteSpace: 'nowrap'}}><strong style={{fontSize: 10}}>ID: {publish.id}</strong></div>
                        <div>HISPS: <strong>{publish.hispCount}</strong></div>
                        {publish.detailsInfo && publish.detailsInfo.mailingOrgCount != null && <div>ORGANIZATIONS: <strong>{publish.detailsInfo.mailingOrgCount}</strong></div>}
                        {publish.detailsInfo && publish.detailsInfo.practiceLocationCount != null && <div>LOCATIONS: <strong>{publish.detailsInfo.practiceLocationCount}</strong></div>}
                        <div>PRACTITIONER ROLES: <strong>{publish.userCount}</strong></div>
                        <div>ENDPOINTS: <strong>{publish.directAddressCount}</strong></div>
                        <div>DATE: <strong>{convertDateToTimeString(publish.publishedTs)}</strong></div>
                        {publish.detailsInfo && publish.detailsInfo.publishabilityMap && <div>CONSUMER ACCESS: <strong>{getConsumerAccessRate(publish.detailsInfo.publishabilityMap)}</strong></div>}

                    </div>}
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                {/*<Grid item xs={12} md={4} lg={4}>*/}
                    {hispsPieData && <BasicPie data={organize()} width={300} height={300} others={othersRef.current}/> }
                </Grid>
                <Grid item xs={12} md={4} lg={4} align='center'>
                    {errorBarData && <BasicBar data={errorBarData} width={500} height={275} />}
                    {/*{errorBarData && <BasicBar data={errorBarData} width={400} height={275} />}*/}
                </Grid>
            </Grid>
    </div>)
}
